import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./redux/userSlice";
import loadingSlice from "./redux/loadingSlice";
import notificationSlice from "./redux/notificationSlice";

const store = configureStore({
  reducer: {
    user: userReducer,
    loading: loadingSlice,
    notification: notificationSlice,
  },
});

export default store;
